import React from "react";
import { Flex, Form, Input, message, Card } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AuthService from "../../services/AuthService";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import { getUserByToken } from "../../store/slices/userSlice";
import classes from "../global_styles.module.css";
import FormItem from "antd/es/form/FormItem";
import BlueButton from "../../components/UI/Buttons/BlueButton";
import Header from "../components/Header/Header";
import MyText from "../../components/UI/Text/MyText";
import Footer from "../components/Footer/Footer";

const LoginPage = () => {
  const [form] = Form.useForm();
  const email = Form.useWatch("email", form);
  const password = Form.useWatch("password", form);

  const navigate = useNavigate();
  const { user, isLoading } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  if (user !== null && isLoading === false) {
    navigate("/profile");
  }

  function handleOnSubmit() {
    form
      .validateFields()
      .then(() => {
        AuthService.login(email, password)
          .then((result) => {
            message.destroy();
            message.success(<IntlMessage id={"success"} />, 5);
            localStorage.setItem("Authorization", result?.data.access_token);
            localStorage.setItem(
              "ExpirationDate",
              result?.data.expiration_date
            );
            localStorage.setItem("Refresh", result?.data.refresh_token);
            dispatch(getUserByToken());
          })
          .catch((result) => {
            message.destroy();
            if (
              result?.response.data === "user not found" ||
              result?.response.data === "password is incorrect"
            ) {
              message.error(
                <IntlMessage id={"incorrectPasswordOrUsername"} />,
                5
              );
            } else {
              message.error(<IntlMessage id={"error"} />, 5);
            }
          });
      })
      .catch(() => {});
  }

  return (
    <Flex
      style={{ width: "100%", position: "relative" }}
      vertical
      align="center"
      justify="flex-start"
    >
      <Header />
      <Flex
        style={{
          width: "100%",
          paddingTop: 250,
          position: "relative",
          overflow: "hidden",
          paddingBottom: 50,
        }}
        vertical
        align="center"
        justify="flex-start"
      >
        <Card
          style={{
            width: "100%",
            maxWidth: 420,
            padding: "40px 30px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            borderRadius: 12,
          }}
          bodyStyle={{ padding: 0 }}
        >
          <Flex
            vertical
            gap={35}
            align="center"
            justify="flex-start"
            style={{ width: "100%" }}
          >
            <MyText style={{ fontSize: "2rem", fontWeight: "bold" }}>
              Хэрэглэгч нэвтрэх
            </MyText>
            <Form
              form={form}
              className={classes.form}
              style={{ width: "100%" }}
              layout="vertical"
            >
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="email"
              >
                <Input rootClassName={classes.formInput} placeholder="И-мэйл" />
              </FormItem>
              <FormItem
                rules={[
                  {
                    required: true,
                    message: <IntlMessage id={"requiredField"} />,
                  },
                ]}
                className={classes.formInputBlock}
                name="password"
              >
                <Input.Password
                  rootClassName={classes.formInput}
                  placeholder="Нууц үг"
                />
              </FormItem>
              <FormItem className={classes.formInputBlock}>
                <Flex
                  style={{ width: "100%", marginTop: 25 }}
                  align="center"
                  justify="center"
                >
                  <BlueButton
                    style={{ width: "100%" }}
                    onClick={handleOnSubmit}
                  >
                    Нэвтрэх
                  </BlueButton>
                </Flex>
              </FormItem>
            </Form>
          </Flex>
        </Card>
      </Flex>
      <Footer />
    </Flex>
  );
};

export default LoginPage;
